export default "__VITE_ASSET__Cjf9lr9h__"